import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";

const CategoriesDragList = (props) => {
  const { items, i } = props;
  return (
    <>
      <div className="bg-light h-100 d-flex align-items-center px-1">
        <FontAwesomeIcon
          icon={faGripVertical}
          className="text-secondary mr-1"
        />
      </div>
      <div className="flex-grow-1 py-3">
        <p className="text-s-10 mb-0 text-capitalize">{items[i].title}</p>
      </div>
    </>
  );
};
export default CategoriesDragList;
